import {Enum} from 'enumify';

export default class SubscriptionStatus extends Enum {}

SubscriptionStatus.initEnum({
  ONBOARDING: {
    statusName: 'Onboarding',
  },
  PENDING: {
    statusName: 'Pending',
  },
  NORMAL: {
    statusName: 'Normal',
  },
  CANCEL: {
    statusName: 'Cancel',
  },
});



// WEBPACK FOOTER //
// ./src/constants/SubscriptionStatus.js